import '../css/app.css';
import './bootstrap';
import { createStore } from 'vuex';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';



import OrderDetail from './Components/order-detail.vue';
import OrderPanel from './Components/order-panel.vue';
import SearchSelecter from './Components/search-selecter.vue'
import store from './store/order'; 
import TransactionPanel from './Components/transaction-panel.vue';


const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Detect Inertia root (requires data-page on #app)
const inertiaEl = document.getElementById('app');
const hasInertia = inertiaEl && inertiaEl.dataset && inertiaEl.dataset.page;
console.log('[NB] App boot. hasInertia:', !!hasInertia, 'el exists:', !!inertiaEl);

if (hasInertia) {
    createInertiaApp({
        title: (title) => `${title} - ${appName}`,
        resolve: (name) =>
            resolvePageComponent(
                `./Pages/${name}.vue`,
                import.meta.glob('./Pages/**/*.vue'),
            ),
        setup({ el, App, props, plugin }) {

            const vue = createApp({ render: () => h(App, props) })
                .use(plugin)
                .use(ZiggyVue)
                .use(store)
                .component('order-detail', OrderDetail)
                .component('order-panel', OrderPanel)
                .component('search-selecter', SearchSelecter)
                .component('transaction-panel', TransactionPanel)
            vue.config.errorHandler = (err, instance, info) => {
                console.error('[NB] Vue error:', err, info);
            };
            const vm = vue.mount(el);
            console.log('[NB] Inertia app mounted');
            return vm;
        },
        progress: {
            color: '#4B5563',
        },
    });
} else {
    // Fallback mount for Blade pages (non-Inertia) that include a div#app
    const mountBladeApp = () => {
        var el = document.getElementById('app');
        console.log('[NB] Blade mount attempt. el exists:', !!el, 'already mounted:', !!(el && el.__vue_app__));
        if (el && !el.__vue_app__) {
            // If transaction props are provided, mount a render-only root using them
            if (window.NB_TRANSACTION_PROPS) {
                console.log('[NB] Using NB_TRANSACTION_PROPS to render transaction-panel');
                // Replace innerHTML to avoid template compiler requirement
                el.innerHTML = '';
                const bladeApp = createApp({
                    render: () => h(TransactionPanel, { 
                        transaction_type: window.NB_TRANSACTION_PROPS.transaction_type,
                        entities: window.NB_TRANSACTION_PROPS.entities,
                        banks: window.NB_TRANSACTION_PROPS.banks,
                        receive_banks: window.NB_TRANSACTION_PROPS.receive_banks,
                        lang: window.NB_TRANSACTION_PROPS.lang,
                    })
                });
                bladeApp.use(store);
                bladeApp.config.errorHandler = (err, instance, info) => {
                    console.error('[NB] Blade Vue error:', err, info);
                };
                bladeApp.mount(el);
                console.log('[NB] Blade transaction-panel mounted via render()');
            } else {
                const bladeApp = createApp({});
                bladeApp.use(store);
                bladeApp.component('order-detail', OrderDetail);
                bladeApp.component('order-panel', OrderPanel);
                bladeApp.component('search-selecter', SearchSelecter);
                bladeApp.component('transaction-panel', TransactionPanel);
                bladeApp.config.errorHandler = (err, instance, info) => {
                    console.error('[NB] Blade Vue error:', err, info);
                };
                bladeApp.mount(el);
                console.log('[NB] Blade app mounted to #app');
            }
        }
    };

    // Mount immediately if the element exists; otherwise wait for DOMContentLoaded
    if (document.getElementById('app')) {
        console.log('[NB] Mounting immediately');
        mountBladeApp();
    } else {
        console.log('[NB] Waiting for DOMContentLoaded');
        document.addEventListener('DOMContentLoaded', mountBladeApp);
    }
}



